import { Get, Post } from "../utils/http-utils";

export const getListDirectory = async (Params) => {
  return Get("/file-browsing", Params)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const downloadListDirectory = async (Params) => {
  return Get("/file-browsing/download", Params)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const postRequestForLatestDirectory = async (requestBody) => {
  return Post("/file-browsing", requestBody)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const uploadSelectedFiles = (requestBody) => {
  return Post("/file-browsing/upload", requestBody)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};
